import React from 'react';

import { createStyles, ListItemText, Theme, WithStyles, withStyles } from '@material-ui/core';
import { get } from 'lodash';
import moment from 'moment';

import { ChipCurrent, Typography } from 'components/v2';
import ListItemNodeAudits from './ListItemNodeAudits';
import { Audit } from './types/auditType';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    chip: {
      marginBottom: unit / 2,
    },
    title: {
      overflowWrap: 'break-word',
    },
  });

export interface ListItemAuditProps extends WithStyles<typeof styles> {
  audit: Audit;
  description?: string;
  current?: boolean;
}

const ListItemAudit: React.FC<ListItemAuditProps> = ({ audit, classes, description, current, ...rest }) => {
  const versionTitle = description || `#${audit._id}`;

  return (
    <ListItemNodeAudits node={audit} {...rest}>
      <ListItemText
        primary={
          <>
            {current && <ChipCurrent className={classes.chip} />}
            <Typography className={classes.title} variant="body1Bold">
              {versionTitle.substring(0, 84)}
            </Typography>
          </>
        }
        secondary={
          <>
            {moment(audit.timestamp as string).format('LLL')} {get(audit.by, 'name')}
          </>
        }
      />
    </ListItemNodeAudits>
  );
};

export default withStyles(styles)(ListItemAudit);
